import React from "react";

const PositionsContext = React.createContext({});

export default PositionsContext;
